import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
 
import {appApiResources} from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class ModeService {

  constructor(private http: HttpClient) {}

  async getMode() {
    try {
      // const httpOptions = {
      //   headers: new HttpHeaders({
      //     "Content-Type": "application/json",
      //     Authorization: `jwt ${idToken}`
      //   })
      // }; 
      let response = await this.http
        .get(`${appApiResources.getMode}`)
        .toPromise();
      return response;
    } catch (error) { 
      return error;
    }
  }
}